module.exports = __webpack_public_path__ + "img/carrousel-video-3.26e5bf6f.png";